function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Trans, useTranslation } from "react-i18next";
import { connect, useSelector } from "react-redux";
import { formValueSelector } from "redux-form";
import { Link } from "react-router-dom";
import Alert from "@mui/material/Alert";
import GoalOption from "../../../../components/react-select/GoalOption";
import GoalSingleValue from "../../../../components/react-select/GoalSingleValue";
import SelectField from "../../../../components/redux-form/SelectField";
import { loadGoalMembersByUserIdAndStateInAndConfirmedAtNotNull } from "../../../../actions";
import { operationTypes, memberStates } from "../../../../constants";
var tKey = "contexts.ExchangeContext.CreateExchangeDialog.ExchangeWizardForm.ExchangeWizardFormGoalStep";
var selector = formValueSelector("exchangeWizard");
function ExchangeWizardFormGoalStep(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var authUserId = useSelector(function (state) {
    return state.authentication.userId;
  });
  var type = useSelector(function (state) {
    return selector(state, "type");
  });
  var goal = useSelector(function (state) {
    return selector(state, "goal");
  });
  var quote = useSelector(function (state) {
    return selector(state, "quote");
  });
  var deletableAndOngoingMemberStatesStr = [memberStates.DELETABLE, memberStates.ONGOING].join(",");
  var loadMembersCall = useSelector(function (state) {
    return state.apiCalls.loadGoalMembersByUserIdAndStateInAndConfirmedAtNotNull[[authUserId, deletableAndOngoingMemberStatesStr].join("-")] || {};
  });
  var members = useSelector(function (state) {
    return state.entities.goalMembers.byUserIdAndStateInAndConfirmedAtNotNull[[authUserId, deletableAndOngoingMemberStatesStr].join("-")];
  }) || [];
  useEffect(function () {
    props.loadGoalMembersByUserIdAndStateInAndConfirmedAtNotNull(authUserId, deletableAndOngoingMemberStatesStr);
  }, []);
  var goalOptions;
  if (type === operationTypes.SELL) {
    if (goal === null) {
      goalOptions = [_objectSpread({
        label: t("".concat(tKey, ".noGoal")),
        value: -1
      }, goal)];
    } else {
      goalOptions = [_objectSpread({
        label: goal.displayableName,
        value: goal.id
      }, goal)];
    }
  } else {
    goalOptions = members.map(function (member) {
      return _objectSpread({
        label: member.goal.displayableName,
        value: member.goal.id,
        picture: member.goal.displayablePicture
      }, member.goal);
    });
    goalOptions.push({
      label: t("".concat(tKey, ".noGoal")),
      value: -1,
      id: -1
    });
  }
  if (!goalOptions && goalOptions.length === 1) props.change("goal", goalOptions[0]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectField, {
    name: "goal",
    id: "goal",
    isLoading: loadMembersCall.isFetching,
    options: goalOptions,
    components: {
      Option: GoalOption,
      SingleValue: GoalSingleValue
    },
    isDisabled: type === operationTypes.SELL || quote
  }), type === operationTypes.BUY && goal && goal.value == -1 && /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    sx: {
      alignItems: "center",
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".noGoal"),
    components: {
      lnk: /*#__PURE__*/React.createElement(Link, {
        to: "/goals/non-finalized?goalWizardFormDialogOpen=true"
      })
    }
  })), type === operationTypes.BUY && goal && goal.open && /*#__PURE__*/React.createElement(Alert, {
    severity: "warning",
    sx: {
      alignItems: "center",
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".noGoal_tip"),
    components: {
      b: /*#__PURE__*/React.createElement("b", null)
    }
  })));
}
export default connect(undefined, {
  loadGoalMembersByUserIdAndStateInAndConfirmedAtNotNull: loadGoalMembersByUserIdAndStateInAndConfirmedAtNotNull
})(ExchangeWizardFormGoalStep);
ExchangeWizardFormGoalStep.propTypes = {
  loadGoalMembersByUserIdAndStateInAndConfirmedAtNotNull: PropTypes.func
};